import React from 'react';
import { Grid, Card, CardMedia, CardContent, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import l1 from '../assets/l1.jpg';
import bu1 from '../assets/bu1.jpg';
import me1 from '../assets/me1.jpg';
import sc1 from '../assets/sc1.jpg';
import comp1 from '../assets/comp1.jpg';
import ed1 from '../assets/ed1.jpg';
import ss1 from '../assets/ss1.jpg';
import ref1 from '../assets/Ref1.jpg';
import na1 from '../assets/Na1.jpg';
import art1 from '../assets/Art1.jpg';
import misc1 from '../assets/misc1.jpg';
import tech1 from '../assets/tech1.jpg';

const categories = [
  { label: 'Law', imageSrc: l1 },
  { label: 'Business', imageSrc: bu1 },
  { label: 'Medical', imageSrc: me1 },
  { label: 'Science', imageSrc: sc1 },
  { label: 'Computers', imageSrc: comp1 },
  { label: 'Education', imageSrc: ed1 },
  { label: 'Social Science', imageSrc: ss1 },
  { label: 'Reference', imageSrc: ref1 },
  { label: 'Nature', imageSrc: na1 },
  { label: 'Art', imageSrc: art1 },
  { label: 'Misc', imageSrc: misc1 },
  { label: 'Technology', imageSrc: tech1 },
];

const ProductCategory = () => {
  return (
    <Grid container spacing={2}>
      {categories.map((category, index) => (
        <Grid item xs={6} sm={4} md={3} key={index} sx={{m:4, mx:'auto'}}>
          <Link to={`/${category.label}`} style={{ textDecoration: 'none' }}>
            <Card className="MuiCard-root" sx={{ maxWidth: 345, boxShadow: 3, '&:hover': { boxShadow: 6, backgroundColor: '#98ff98' } }}>
              <CardMedia component="img" height="140" image={category.imageSrc} alt={category.label} />
              <CardContent>
                <Typography variant="h6" sx={{ textAlign: 'center' }}>{category.label}</Typography>
              </CardContent>
            </Card>
          </Link>
        </Grid>
      ))}
    </Grid>
  );
};

export default ProductCategory;
